import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

function Contact() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const googleMapsUrl = "https://maps.google.com/?q=42,Kaluramji+Ki+Bari,Gayriyawas,Udaipur,Rajasthan,313002";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      // MongoDB mein save karo
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });
      const result = await response.json();

      if (response.ok) {
        // EmailJS se notification bhejo
        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID,
          {
            from_name: formData.name,
            phone: formData.phone,
            from_email: formData.email,
            message: formData.message
          },
          EMAILJS_PUBLIC_KEY
        );

        setSuccess(true);
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        setError(result.error || "Failed to send message.");
      }
    } catch (err) {
      setError("Something went wrong. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page contact-page">
      <section className="page-hero">
        <div className="section-label">{t("contact.label")}</div>
        <h1>{t("contact.title")}</h1>
        <p>{t("contact.subtitle")}</p>
      </section>

      <section className="section-block">
        <div className="container">
          <div className="contact-wrapper">
            {/* Info Side */}
            <div className="contact-info">
              <div className="section-label">{t("contact.letsConnect")}</div>
              <h2>{t("contact.loveToHear")}</h2>
              <p>{t("contact.description")}</p>

              {/* WEBSITE */}
              <div className="info-item">
                <div className="info-icon">🌐</div>
                <div>
                  <h4>{t("contact.website")}</h4>
                  <p>
                    <a href="https://chirayumedicos.com" className="contact-link-accent">chirayumedicos.com</a>
                  </p>
                </div>
              </div>

              {/* PHONE */}
              <div className="info-item">
                <div className="info-icon">📞</div>
                <div>
                  <h4>{t("contact.phone")}</h4>
                  <p>
                    <a href="tel:+919166446452" className="contact-link">+91 9166446452</a>,
                    <a href="tel:+919928212439" className="contact-link"> +91 9928212439</a>
                  </p>
                </div>
              </div>

              {/* EMAIL */}
              <div className="info-item">
                <div className="info-icon">✉️</div>
                <div>
                  <h4>{t("contact.email")}</h4>
                  <p>
                    <a href="mailto:admin@chirayumedicos.com" className="contact-link">admin@chirayumedicos.com</a>,
                    <a href="mailto:sales@chirayumedicos.com" className="contact-link"> sales@chirayumedicos.com</a>
                  </p>
                </div>
              </div>

              {/* ADDRESS */}
              <div className="info-item address-box">
                <div className="info-icon">📍</div>
                <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" className="address-link">
                  <div>
                    <h4>{t("contact.address")}</h4>
                    <p>
                      42, Kaluramji Ki Bari, Gayriyawas,<br />
                      Udaipur, Rajasthan, Pin: 313002
                    </p>
                    <span className="map-btn">{t("contact.findOnMap")}</span>
                  </div>
                </a>
              </div>
            </div>

            {/* Form Side */}
            <div className="contact-form-box">
              {success && <div className="form-status success-msg">{t("contact.form.success")}</div>}
              {error && <div className="form-status error-msg">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>{t("contact.form.yourName")}</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder={t("contact.form.namePlaceholder")} required />
                </div>
                <div className="form-group">
                  <label>{t("contact.form.phoneNumber")}</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder={t("contact.form.phonePlaceholder")} required />
                </div>
                <div className="form-group">
                  <label>{t("contact.form.email")}</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder={t("contact.form.emailPlaceholder")} required />
                </div>
                <div className="form-group">
                  <label>{t("contact.form.message")}</label>
                  <textarea name="message" value={formData.message} onChange={handleChange} placeholder={t("contact.form.messagePlaceholder")} rows={4} required />
                </div>
                <button type="submit" className="btn-primary full-width" disabled={loading}>
                  {loading ? t("contact.form.sending") : t("contact.form.sendMessage")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
